// extracted by mini-css-extract-plugin
export default {"imgArea":"middleArea_imgArea__zTfZR","fullSize":"middleArea_fullSize__x+2sh","bottomLeftText":"middleArea_bottomLeftText__f7nEe"};